import OBase from './OBase';

import * as Geometry from '../geometry';
import FlattenTree from './FlattenTree';

export default class InteractiveVisible extends OBase {
  constructor (src) {
    super(src);

    this.visibles = [];
  }

  update () {
    let gInput = this.getObjectInput('geos');
    let gOutput = this.outputs['geos'].paramObject;
    let iOutput = this.outputs['indices'].paramObject;
    let g2Output = this.outputs['hidden geos'].paramObject;
    let i2Output = this.outputs['hidden indices'].paramObject;

    let fInput = FlattenTree.flatten(gInput);

    var gOutTree = new Geometry.DataTree();
    var iOutTree = new Geometry.DataTree();
    var g2OutTree = new Geometry.DataTree();
    var i2OutTree = new Geometry.DataTree();
    if (fInput.branches.length > 0) {
      if (fInput.branches[0].length !== this.visibles.length) {
        this.visibles = [];
        for (let i = 0; i < fInput.branches[0].length; i++) {
          this.visibles.push(true);
        }
      }

      for (let i = 0; i < fInput.branches[0].length; i++) {
        let geo = fInput.branches[0][i];

        geo.setSelectable(true);
        geo.setComponent(this);
        geo.setIndex(i);

        if (this.visibles[i]) {
          geo.setVisible(true);
          gOutTree.add(geo, fInput.paths[0]);
          iOutTree.add(i, fInput.paths[0]);
        } else {
          geo.setVisible(false);
          g2OutTree.add(geo, fInput.paths[0]);
          i2OutTree.add(i, fInput.paths[0]);
        }
      }
    }

    gOutput.value = gOutTree;
    iOutput.value = iOutTree;
    g2Output.value = g2OutTree;
    i2Output.value = i2OutTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/InteractiveVisible.js